import { render } from "./DataServiceProviderView.vue?vue&type=template&id=094486ec&scoped=true"
import script from "./DataServiceProviderView.vue?vue&type=script&lang=js"
export * from "./DataServiceProviderView.vue?vue&type=script&lang=js"

import "./DataServiceProviderView.vue?vue&type=style&index=0&id=094486ec&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094486ec"]])

export default __exports__